export default __webpack_public_path__ + "static/histogram-with-specified-bins-c8b807047bb1938f7cc8f8aa86d8797d.png";